import { Controller } from '@hotwired/stimulus';
import { captureException } from '@sentry/browser';
import { saveVisit, cleanupOldVisits } from '../../utils/ad_visit_db_manager';

export default class MainManualController extends Controller {
  static outlets = ['details--fullscreen-gallery'];
  static values = { adId: String };

  connect() {
    void this.saveVisit();
    void this.cleanupOldVisits();
  }

  async saveVisit() {
    if (!this.hasAdIdValue || !this.adIdValue) {
      return;
    }

    try {
      await saveVisit(this.adIdValue);
    } catch (error) {
      captureException(error);
    }
  }

  async cleanupOldVisits() {
    try {
      await cleanupOldVisits();
    } catch (error) {
      captureException(error);
    }
  }

  pushEvent(event) {
    window.GTM.pushEvent(event.params.event);
  }

  openFullscreenGallery(event) {
    this.detailsFullscreenGalleryOutlet.openModal(event.params.imageCount);
  }
}
